document.addEventListener('DOMContentLoaded', () => {

  class ProductManager {
    constructor() {
      this.API_BASE_URL = 'https://d24u4mowe6x0rg.cloudfront.net/api';
      this.IFRAME_ORIGIN = "https://d3rm6itks8gufu.cloudfront.net/";

      this.loaderImages = {
        dog: 'loader-image-dog',
        cat: 'loader-image-cat',
        default: 'loader-image-dog'
      };

      this.productTypeMapping = {
        'collar': 'DOG_COLLAR',
        'cat_collar': 'CAT_COLLAR',
        'martingale': 'MARTINGALE_COLLAR',
        'leash': 'DOG_LEASH',
        'cat_leash': 'CAT_LEASH'
      };

      this.masterObject = {
        selectedSizes: '',
        selectedBuckleColor: '',
        selectedBuckleName: '',
        selectedBuckleColorType: '',
        collectionId: '',
        collectionTitle: '',
        productData: null,
      };
      this.currentProductType = 'dog-collar';
      this.designerObject = {
        productId: '',
        collectionId: '',
      };
      document.addEventListener('buckleColorSelected', this.handleBuckleColorSelection.bind(this));

      this.createdCustomProductId = null;
      this.createdCustomVariantId = null;
      this.createdCustomProductObj = null;
      this.currentUpdatePromise = null;
      this.activeAbortController = null;

      // Initialize from localStorage
      const productContainer = document.getElementById('product-container');
      const parentProductId = productContainer ? productContainer.dataset.productId : null;
      if (parentProductId) {
        try {
          this.createdCustomProductId = localStorage.getItem('joe_custom_product_id_' + parentProductId) || null;
          const cachedVariantId = localStorage.getItem('joe_custom_variant_id_' + parentProductId);
          this.createdCustomVariantId = cachedVariantId ? parseInt(cachedVariantId, 10) : null;
        } catch (e) {
          console.warn('LocalStorage not accessible:', e);
        }
      }


      this.elements = {
        openIframeBtn: document.querySelector('#open-iframe-btn'),
        iframeOverlay: document.getElementById('iframeOverlay'),
        closeIframeBtn: document.getElementById('closeIframe'),
        cartForm: document.getElementById('add-to-cart-form'),
        backBtn: document.getElementById('back-btn'),

        openSecondIframeBtn: document.querySelector('#open-second-iframe-btn'),
        secondIframeOverlay: document.getElementById('secondIframeOverlay'),
        closeSecondIframeBtn: document.getElementById('closeSecondIframe'),

        returnPolicyModalBtn: document.getElementById('openRetunPolicyModal'),
        returnPolicyModal: document.getElementById('retunPolicyModal'),
        closeReturnPolicyModalBtn: document.getElementById('closeModalCustom'),

        askQueModalBtn: document.getElementById('openAskQueModal'),
        askQueModal: document.getElementById('askQueModal'),
        closeAskQueModalBtn: document.getElementById('closeAskQueCustom'),

        mainModal: document.getElementById('myModal'),
        openMainModalBtn: document.getElementById('openModal'),
        closeMainModalBtn: document.getElementById('closeModal'),

        signInButton: document.querySelector('.sign-in-btn')
      };

      this.updateHeaderHeight();
      window.addEventListener('resize', () => this.updateHeaderHeight());
      window.addEventListener('load', () => this.updateHeaderHeight());
      window.addEventListener('pageshow', () => {
        this.updateHeaderHeight();
        this.closeIframe();
      });

      this.initializeProductCustomizer();
      this.initializeModalHandlers();
      this.initializeAddToCart();
    }

    updateHeaderHeight() {
      const headerEl = document.querySelector('.header-wrapper') || document.querySelector('[data-section-type="header-section"]') || document.querySelector('.site-header');
      if (headerEl) {
        document.documentElement.style.setProperty('--header-height', headerEl.offsetHeight + 'px');
      }
    }

    handleBuckleColorSelection(event) {
      this.masterObject.selectedBuckleColor = event.detail.buckleColor;
      this.masterObject.selectedBuckleName = event.detail.buckleName;
      this.masterObject.selectedBuckleColorType = event.detail.buckleColorType;

      // Buckle color changed: reset cache and precreate
      this.currentUpdatePromise = null;
      this.createdCustomProductObj = null;
      this.precreateVariant();
    }

    syncSelectedBuckleFromDOM() {
      const activeSwatch = document.querySelector('#color-container .wrapper.active');
      if (activeSwatch) {
        this.masterObject.selectedBuckleColor = activeSwatch.getAttribute('data-color') || activeSwatch.dataset.color || '';
        this.masterObject.selectedBuckleName = activeSwatch.getAttribute('data-name') || activeSwatch.dataset.name || '';
        this.masterObject.selectedBuckleColorType = activeSwatch.getAttribute('data-type') || activeSwatch.dataset.type || '';

        // Fallbacks if data attributes aren't parsed or set
        if (!this.masterObject.selectedBuckleName) {
          const nameEl = activeSwatch.querySelector('.color-name');
          if (nameEl) this.masterObject.selectedBuckleName = nameEl.textContent.trim();
        }
        if (!this.masterObject.selectedBuckleColor) {
          const colorCircleEl = activeSwatch.querySelector('.color-circle');
          if (colorCircleEl) this.masterObject.selectedBuckleColor = colorCircleEl.style.backgroundColor;
        }
        if (!this.masterObject.selectedBuckleColorType) {
          if (document.querySelector('.metal-btn.active')) {
            this.masterObject.selectedBuckleColorType = 'metal';
          } else if (document.querySelector('.plastic-btn.active')) {
            this.masterObject.selectedBuckleColorType = 'plastic';
          }
        }
      }
    }

    initializeProductCustomizer() {
      this.initializeForm();
      this.initializeEventListeners();
      this.initializeProductData();

      // Sync active state from query param if present
      const urlParams = new URLSearchParams(window.location.search);
      const queryProduct = urlParams.get('product') || urlParams.get('type');
      if (queryProduct) {
        const targetCard = document.querySelector(`.product-type-grid-card[data-product-type="${queryProduct}"]`);
        if (targetCard) {
          document.querySelectorAll('.product-type-grid-card').forEach(card => card.classList.remove('active'));
          targetCard.classList.add('active');
          this.currentProductType = queryProduct;
        }
      }

      this.syncSelectedBuckleFromDOM();
    }

    initializeProductData() {
      const productContainer = document.getElementById('product-container');
      const productId = productContainer ? productContainer.dataset.productId : null;

      if (productId) {
        this.fetchAndRenderVariants(productId).then(() => {
          if (this.createdCustomProductId) {
            fetch(`${this.API_BASE_URL}/product/${this.createdCustomProductId}`)
              .then(res => {
                if (!res.ok) throw new Error("HTTP error");
                return res.json();
              })
              .then(data => {
                if (data && data.success === true) {
                  console.log("Cached custom product is valid on server.");
                } else {
                  throw new Error("Product success is not true");
                }
              })
              .catch(err => {
                console.warn("Cached custom product verification failed. Re-creating...", err);
                try {
                  localStorage.removeItem('joe_custom_product_id_' + productId);
                  localStorage.removeItem('joe_custom_variant_id_' + productId);
                } catch (e) { }
                this.createdCustomProductId = null;
                this.createdCustomVariantId = null;
                this.createdCustomProductObj = null;
                this.precreateVariant();
              });
          } else {
            setTimeout(() => {
              this.precreateVariant();
            }, 200);
          }
        });
      } else {
        console.warn('No product ID found in URL or DOM');
      }
    }

    initializeForm() {
      const hiddenFields = [
        'quantity',
        'properties[size]',
        'properties[pattern]',
        'properties[customText]'
      ];

      hiddenFields.forEach(fieldName => {
        if (!this.elements.cartForm.querySelector(`[name="${fieldName}"]`)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = fieldName;
          this.elements.cartForm.appendChild(input);
        }
      });
    }

    initializeEventListeners() {
      document.querySelectorAll('.product-type-grid-card').forEach(card => {
        card.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const productType = card.getAttribute('data-product-type');
          if (productType) {
            this.openIframeWithProductType(productType);
          }
        });
      });

      this.elements.openIframeBtn?.addEventListener('click', () => this.openIframe());
      this.elements.closeIframeBtn?.addEventListener('click', () => this.closeIframe());
      this.elements.backBtn?.addEventListener('click', () => this.closeIframe());
      this.elements.iframeOverlay?.addEventListener('click', (event) => {
        if (event.target === this.elements.iframeOverlay) {
          this.closeIframe();
        }
      });
      this.elements.openSecondIframeBtn?.addEventListener('click', () => this.openSecondIframe());
      this.elements.closeSecondIframeBtn?.addEventListener('click', () => this.closeSecondIframe());
      this.elements.secondIframeOverlay?.addEventListener('click', (event) => {
        if (event.target === this.elements.secondIframeOverlay) {
          this.closeSecondIframe();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.elements.iframeOverlay && this.elements.iframeOverlay.style.display === 'flex') {
          this.closeIframe();
        }
      });

      window.addEventListener('message', (event) => this.handleIframeMessage(event));
      this.elements.cartForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(this.elements.cartForm);
        this.submitToCart(formData);
      });
      window.addEventListener('message', (event) => this.handleIframe(event));

      // Listen for option changes (size, buckle type)
      document.addEventListener('click', (e) => {
        if (e.target && (e.target.classList.contains('size-btn') || e.target.classList.contains('metal-btn') || e.target.classList.contains('plastic-btn') || e.target.closest('.metal-btn') || e.target.closest('.plastic-btn'))) {
          this.currentUpdatePromise = null;
          this.createdCustomProductObj = null;
          setTimeout(() => {
            this.precreateVariant();
          }, 50);
        }
      });
    }

    handleIframe(event) {
      const sanitizedOrigin = event.origin.replace(/\/$/, '');
      if (sanitizedOrigin === 'https://d3rm6itks8gufu.cloudfront.net/' || (event.data && event.data.type === 'end-user')) {
        console.warn('first iframe message received:', event.data);
        if (event.data && event.data.message === 'send data') {
          this.sendDataToIframe();
        }
      }
    }
    
    initializeModalHandlers() {
      if (this.elements.returnPolicyModalBtn) {
        this.elements.returnPolicyModalBtn.onclick = () => {
          this.elements.returnPolicyModal.style.display = 'block';
        };
      }

      if (this.elements.closeReturnPolicyModalBtn) {
        this.elements.closeReturnPolicyModalBtn.onclick = () => {
          this.elements.returnPolicyModal.style.display = 'none';
        };
      }

      if (this.elements.askQueModalBtn) {
        this.elements.askQueModalBtn.onclick = () => {
          this.elements.askQueModal.style.display = 'block';
        };
      }

      if (this.elements.closeAskQueModalBtn) {
        this.elements.closeAskQueModalBtn.onclick = () => {
          this.elements.askQueModal.style.display = 'none';
        };
      }

      if (this.elements.openMainModalBtn) {
        this.elements.openMainModalBtn.onclick = () => {
          this.elements.mainModal.style.display = 'flex';
        };
      }

      if (this.elements.closeMainModalBtn) {
        this.elements.closeMainModalBtn.onclick = () => {
          this.elements.mainModal.style.display = 'none';
        };
      }

      window.onclick = (event) => {
        if (event.target === this.elements.returnPolicyModal) {
          this.elements.returnPolicyModal.style.display = 'none';
        }
        if (event.target === this.elements.askQueModal) {
          this.elements.askQueModal.style.display = 'none';
        }
        if (event.target === this.elements.mainModal) {
          this.elements.mainModal.style.display = 'none';
        }
      };

      if (this.elements.returnPolicyModal) this.elements.returnPolicyModal.style.display = 'none';
      if (this.elements.askQueModal) this.elements.askQueModal.style.display = 'none';
      if (this.elements.mainModal) this.elements.mainModal.style.display = 'none';
    }

    getPrecreatePayload() {
      const selectedSizeButton = document.querySelector('.size-btn.selected');
      this.syncSelectedBuckleFromDOM();

      if (!selectedSizeButton) return null;

      const productContainer = document.getElementById('product-container');
      const productId = productContainer ? productContainer.dataset.productId : null;

      const selectedVariantData = JSON.parse(selectedSizeButton.getAttribute('data-variant'));
      const selectedSize = selectedSizeButton.textContent.trim();
      const selectedPrefix = selectedVariantData.prefix || '';

      const productName = (this.masterObject.productData && this.masterObject.productData.name) || 'Custom Product';
      const productPrice = selectedVariantData.price || 0;

      const formatCamelCase = (str) => {
        if (!str) return '';
        return str
          .split(/[-_ ]+/)
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      };

      const formattedProductType = formatCamelCase(this.currentProductType);
      const formattedBuckleColor = formatCamelCase(this.masterObject.selectedBuckleName);
      const formattedBuckleType = formatCamelCase(this.masterObject.selectedBuckleColorType);

      const firstImageEl = document.querySelector('.product-main-image-container img');
      const firstImageUrl = firstImageEl ? firstImageEl.src : '';

      const productNameMap = {
        'dog-collar': 'Custom Dog Collar',
        'collar': 'Custom Dog Collar',
        'cat-collar': 'Custom Cat Collar',
        'cat_collar': 'Custom Cat Collar',
        'martingale': 'Custom Dog Martingale',
        'martingale-collar': 'Custom Dog Martingale',
        'dog-leash': 'Custom Dog Leash',
        'leash': 'Custom Dog Leash',
        'dog-bandana': 'Custom Dog Bandana',
        'bandana': 'Custom Dog Bandana',
        'dog-harness': 'Custom Dog Harness',
        'harness': 'Custom Dog Harness',
      };
      const resolvedProductName = productNameMap[this.currentProductType] || `Custom ${formattedProductType}`;

      return {
        name: resolvedProductName,
        price: productPrice,
        variants: [{
          price: productPrice,
          sku: `CUST-${productId}-${Date.now()}`,
        }],
        properties: {
          _size: selectedSize,
          buckleColor: formattedBuckleColor || '',
          _type: 'customize',
          _uuid: `customize-${Date.now()}`,
          _originalProductUrl: window.location.href,
          _image: firstImageUrl || '',
          _design: productName || 'Custom Design',
          _prefix: selectedPrefix || '',
        }
      };
    }

    async precreateVariant() {
      const payload = this.getPrecreatePayload();
      if (!payload) return;

      if (this.activeAbortController) {
        this.activeAbortController.abort();
      }
      this.activeAbortController = new AbortController();
      const { signal } = this.activeAbortController;

      const isCreation = (this.createdCustomProductId === null);
      const url = isCreation
        ? `${this.API_BASE_URL}/shopify-product/create`
        : `${this.API_BASE_URL}/product/update/${this.createdCustomProductId}`;
      const method = isCreation ? 'POST' : 'PUT';

      this.currentUpdatePromise = fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(isCreation ? payload : { price: payload.price }),
        signal: signal
      })
        .then(res => {
          if (!res.ok) {
            const errType = isCreation ? 'create' : 'update';
            const err = new Error(`Failed to ${errType} custom variant`);
            err.status = res.status;
            err.actionType = errType;
            throw err;
          }
          return res.json();
        })
        .then(createdProduct => {
          const productContainer = document.getElementById('product-container');
          const parentProductId = productContainer ? productContainer.dataset.productId : null;

          if (isCreation) {
            if (!createdProduct.product?.variants?.[0]) {
              throw new Error('No variant found in product response');
            }
            this.createdCustomProductId = createdProduct.product.id;
            this.createdCustomVariantId = createdProduct.product.variants[0].id;
            this.createdCustomProductObj = createdProduct.product;
            if (parentProductId) {
              try {
                localStorage.setItem('joe_custom_product_id_' + parentProductId, this.createdCustomProductId);
                localStorage.setItem('joe_custom_variant_id_' + parentProductId, this.createdCustomVariantId);
              } catch (e) {
                console.warn('Failed to save precreated product to localStorage:', e);
              }
            }
          } else {
            this.createdCustomProductObj = createdProduct.product;
          }
          return this.createdCustomProductObj;
        })
        .catch(err => {
          if (err.name === 'AbortError') {
            console.log('API request aborted due to a newer option change');
            throw err;
          } else {
            console.error("precreateVariant API error details:", err);
            const productContainer = document.getElementById('product-container');
            const parentProductId = productContainer ? productContainer.dataset.productId : null;

            if (err.actionType === 'update') {
              console.warn("Update failed. Clearing localStorage and retrying as creation...");
              if (parentProductId) {
                try {
                  localStorage.removeItem('joe_custom_product_id_' + parentProductId);
                  localStorage.removeItem('joe_custom_variant_id_' + parentProductId);
                } catch (e) { }
              }
              this.createdCustomProductId = null;
              this.createdCustomVariantId = null;
              this.createdCustomProductObj = null;
              return this.precreateVariant();
            }
            throw err;
          }
        });

      return this.currentUpdatePromise;
    }

    async initializeAddToCart() {
      const productContainer = document.getElementById('product-container');
      const productId = productContainer.dataset.productId;

      if (this.elements.signInButton) {
        this.elements.signInButton.addEventListener('click', async () => {
          const selectedSizeButton = document.querySelector('.size-btn.selected');
          this.syncSelectedBuckleFromDOM();
          const buckleColor = this.masterObject.selectedBuckleColor;

          if (!selectedSizeButton && !buckleColor) {
            this.showNotification('Please select both Collar Size and Hardware Color.', 'error');
            const targetSection = document.getElementById('sizing-select-container');

            scrollToElement(targetSection, "size");
            triggerZoomAnimation(targetSection);

            return;
          }
          if (!selectedSizeButton) {
            this.showNotification('Please select a Collar Size.', 'error');
            const targetSection = document.getElementById('sizing-select-container');

            scrollToElement(targetSection, "size");
            triggerZoomAnimation(targetSection);
            return;
          }

          if (!buckleColor) {
            this.showNotification('Please select a Hardware Color.', 'error');

            const targetSection = document.getElementById('buckle-detail-section');
            scrollToElement(targetSection, "buckle");
            triggerZoomAnimation(targetSection);
            return;
          }

          try {
            this.setWithoutCustomizationLoading(true);
            if (!this.currentUpdatePromise) {
              this.precreateVariant();
            }
            if (!this.currentUpdatePromise) {
              throw new Error('Could not start custom product creation');
            }

            this.currentUpdatePromise
              .then(async (createdCustomProductObj) => {
                const product = await this.fetchProductData(productId);
                if (!product) {
                  this.showNotification('Product not found.', 'error');
                  this.setWithoutCustomizationLoading(false);
                  return;
                }
                const selectedSize = selectedSizeButton.textContent.trim();
                const productName = product.name || 'Custom Product';

                const selectedVariantData = JSON.parse(selectedSizeButton.getAttribute('data-variant'));
                const targetProductObj = {
                  title: productName,
                  variants: [{
                    id: this.createdCustomVariantId,
                    price: selectedVariantData.price || 0
                  }]
                };
                await this.addToCart(targetProductObj, selectedSize, product.images, productName);

                if (productId) {
                  try {
                    localStorage.removeItem('joe_custom_product_id_' + productId);
                    localStorage.removeItem('joe_custom_variant_id_' + productId);
                  } catch (e) { }
                }
                this.createdCustomProductId = null;
                this.createdCustomVariantId = null;
                this.createdCustomProductObj = null;
                this.currentUpdatePromise = null;

                // Immediately precreate a new custom product for the next addition
                this.precreateVariant();
              })
              .catch(err => {
                console.error("Add to cart error details:", err);
                this.showNotification('Could not create custom product. Please try again.', 'error');
                this.setWithoutCustomizationLoading(false);
              });

          } catch (error) {
            this.setWithoutCustomizationLoading(false);
            console.error('Error in sign-in product creation:', error);
            this.showNotification('Failed to process your order', 'error');
          }
        });
      }
    }

    setWithoutCustomizationLoading(isLoading) {
      const buttonTextEl = this.elements.signInButton ? this.elements.signInButton.querySelector('.button-text') : null;
      if (this.elements.signInButton) {
        if (isLoading) {
          this.elements.signInButton.style.pointerEvents = 'none';
          if (buttonTextEl) buttonTextEl.textContent = 'processing...';
        } else {
          this.elements.signInButton.style.pointerEvents = 'auto';
          if (buttonTextEl) buttonTextEl.textContent = 'ADD TO CART';
        }
      }
      const loader = document.getElementById("button-without-customization");
      if (loader) loader.style.display = "none";
    }

    async fetchProductData(productId) {
      try {
        const response = await fetch(`${this.API_BASE_URL}/product/${productId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        const collectionIdInput = document.querySelector('#collection_id');
        const collectionTitleInput = document.querySelector('#collection_title');
        this.masterObject.productData = data.product;
        this.designerObject.productId = productId;
        this.designerObject.collectionId = collectionIdInput ? collectionIdInput.value : '';
        this.masterObject.collectionId = collectionIdInput ? collectionIdInput.value : '';
        this.masterObject.collectionTitle = collectionTitleInput ? collectionTitleInput.value : '';

        return data.product;
      } catch (error) {
        console.error('Error fetching product data:', error);
        this.masterObject.productData = null;
        this.masterObject.productImages = [];
        return null;
      }
    }

    async addToCart(product, selectedSize, images, productName) {
      try {
        const selectedSizeButton = document.querySelector('.size-btn.selected');
        const selectedVariantData = selectedSizeButton ? JSON.parse(selectedSizeButton.getAttribute('data-variant')) : null;
        const selectedPrefix = selectedVariantData ? (selectedVariantData.prefix || '') : '';

        const getBuckleImageUrl = (imageUrls, selectedBuckleColor, selectedMaterial) => {
          const normalizedSelectedColor = selectedBuckleColor.trim().toLowerCase();
          const normalizedSelectedMaterial = (selectedMaterial || '').trim().toLowerCase();
          const matchedImage = imageUrls.find(url => {
            const filename = url.split('/').pop().toLowerCase();

            // Check color
            let colorMatch = false;
            if (filename.includes("rose_gold") || filename.includes("rosegold") || filename.includes("rose-gold")) {
              colorMatch = normalizedSelectedColor === "rose gold" || normalizedSelectedColor === "rosegold";
            } else if (filename.includes("gold")) {
              colorMatch = normalizedSelectedColor === "gold";
            } else if (filename.includes("silver")) {
              colorMatch = normalizedSelectedColor === "silver";
            }

            // Check material
            let materialMatch = false;
            if (filename.includes("-metal-") || filename.includes("_metal_") || filename.includes("metal")) {
              materialMatch = normalizedSelectedMaterial === "metal";
            } else if (filename.includes("-plastic-") || filename.includes("_plastic_") || filename.includes("plastic")) {
              materialMatch = normalizedSelectedMaterial === "plastic";
            }

            return colorMatch && materialMatch;
          });

          if (matchedImage) {
            return matchedImage;
          }
          // Fallback to color-only matching
          return imageUrls.find(url => {
            const filename = url.split('/').pop().toLowerCase();
            if (filename.includes("rose_gold") || filename.includes("rosegold") || filename.includes("rose-gold")) {
              return normalizedSelectedColor === "rose gold" || normalizedSelectedColor === "rosegold";
            } else if (filename.includes("gold")) {
              return normalizedSelectedColor === "gold";
            } else if (filename.includes("silver")) {
              return normalizedSelectedColor === "silver";
            }
            return false;
          });
        };

        const formatCamelCase = (str) => {
          if (!str) return '';
          return str
            .split(/[-_ ]+/)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
        };

        const variantId = product.variants[0].id;
        const variantPrice = product.variants[0].price;
        const productContainer = document.getElementById('product-container');
        const productId = productContainer.dataset.productId;
        const products = await this.getProductById(productId);
        const buckleColor = this.masterObject.selectedBuckleName || 'Default';
        const buckleMaterial = this.masterObject.selectedBuckleColorType || '';
        const matchingImageUrl = getBuckleImageUrl(images, buckleColor, buckleMaterial);


        const cartPayload = {
          items: [{
            id: variantId,
            quantity: 1,
            price: variantPrice,
            name: product.title,
            properties: {
              _size: selectedSize,
              _Type: 'customize',
              _UUID: `customize-${Date.now()}`,
              _OriginalProductUrl: window.location.href,
              _image: matchingImageUrl,
              _hardwareColor: formatCamelCase(this.masterObject.selectedBuckleName) || 'Default',
              _buckleMaterial: formatCamelCase(this.masterObject.selectedBuckleColorType) || 'Default',
              _bucklePreviewColor: this.masterObject.selectedBuckleColor || '#F5FDF9',
              _product_type: formatCamelCase(this.currentProductType),
              _design: productName,
              _prefix: selectedPrefix || ''
            }
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(cartPayload)
        });

        if (!response.ok) {
          this.setWithoutCustomizationLoading(false);
          throw new Error('Failed to add product to cart');
        }

        if (typeof theme !== 'undefined' && theme.CartDrawer) {
          const cartDrawer = new theme.CartDrawer();
          cartDrawer.open();
          this.setWithoutCustomizationLoading(false);
        } else {
          const event = new CustomEvent('cart:open');
          document.dispatchEvent(event);
          this.setWithoutCustomizationLoading(false);
        }

        this.showNotification('Product added to cart successfully', 'success');

      } catch (error) {
        this.setWithoutCustomizationLoading(false);
        console.error('Error adding product to cart:', error);
        this.showNotification('Failed to add item to cart', 'error');
      }
    }

    showNotification(message, type = 'success') {
      document.querySelectorAll('.notification').forEach(n => n.remove());

      const notification = document.createElement('div');
      notification.className = `notification notification--${type}`;
      notification.textContent = message;
      document.body.appendChild(notification);

      setTimeout(() => notification.remove(), 4000);
    }

    sendDataToIframe() {
      document.getElementById("iframe-loading-screen").style.display = "none";
      let getIframe = document.querySelector("#myIframe")
      const selectedSize = document.querySelectorAll(".size-btn")
      let selectedValue = null;

      selectedSize.forEach((size) => {
        if (size.classList.contains("selected")) {
          selectedValue = size.getAttribute("data-variant");
        }
      });

      this.masterObject.selectedSizes = JSON.parse(selectedValue);
      this.syncSelectedBuckleFromDOM();

      if (getIframe.src != "") {
        setTimeout(() => {
          getIframe.contentWindow.postMessage(this.masterObject, "*");

          const productType = this.currentProductType || 'dog-collar';
          const message = {
            type: 'ROUTE_CHANGE',
            productType: productType
          };

          if (productType === 'cat-collar') {
            message.cat = true;
          } else if (productType === 'dog-leash') {
            message.leash = true;
          } else if (productType === 'martingale-collar') {
            message.martingale = true;
          } else if (productType === 'dog-harness') {
            message.harness = true;
          } else if (productType === 'dog-bandana') {
            message.bandana = true;
          }

          getIframe.contentWindow.postMessage(message, "*");
        }, 2000);

        console.warn(this.masterObject, "selectedData-------");
      }
    }

    openIframe() {
      const selectedSizeBtn = document.querySelector('.size-btn.selected');
      const sizeVal = selectedSizeBtn ? selectedSizeBtn.textContent.trim() : '';

      this.syncSelectedBuckleFromDOM();
      const hardwareVal = this.masterObject.selectedBuckleColorType || '';
      const hardwareColorVal = this.masterObject.selectedBuckleName || '';

      const urlParams = new URLSearchParams(window.location.search);
      const productTitleEl = document.querySelector('.product-name');
      const productTitle = productTitleEl ? productTitleEl.textContent.trim() : '';
      const patternVal = urlParams.get('pattern') || productTitle;

      const activeCard = document.querySelector('.product-type-grid-card.active');
      const productType = activeCard ? activeCard.getAttribute('data-product-type') : 'dog-collar';
      this.currentProductType = productType;

      const baseUrl = "https://d3rm6itks8gufu.cloudfront.net/";
      const iframeUrl = new URL(baseUrl + productType);

      if (sizeVal) iframeUrl.searchParams.set('size', sizeVal);
      if (patternVal) iframeUrl.searchParams.set('pattern', patternVal);
      if (hardwareVal) iframeUrl.searchParams.set('hardware', hardwareVal);
      if (hardwareColorVal) iframeUrl.searchParams.set('hardware_color', hardwareColorVal);

      // Set product type specific search parameter
      if (productType === 'cat-collar') {
        iframeUrl.searchParams.set('cat', 'true');
      } else if (productType === 'dog-leash') {
        iframeUrl.searchParams.set('leash', 'true');
      } else if (productType === 'martingale-collar') {
        iframeUrl.searchParams.set('martingale', 'true');
      } else if (productType === 'dog-harness') {
        iframeUrl.searchParams.set('harness', 'true');
      } else if (productType === 'dog-bandana') {
        iframeUrl.searchParams.set('bandana', 'true');
      }

      window.scrollTo({ top: 0, behavior: 'instant' });
      this.updateHeaderHeight();
      document.getElementById("iframe-loading-screen").style.display = "flex";
      this.elements.iframeOverlay.style.display = 'flex';
      document.body.classList.add('iframe-open');
      document.body.style.overflow = 'hidden';

      let getIframe = document.querySelector("#myIframe");
      getIframe.src = iframeUrl.toString();

      document.getElementById("iframe-loading-screen").style.display = "none";
      this.sendDataToIframe();
    }
    openIframeWithProductType(productType) {
      const selectedSizeBtn = document.querySelector('.size-btn.selected');
      const sizeVal = selectedSizeBtn ? selectedSizeBtn.textContent.trim() : '';

      this.syncSelectedBuckleFromDOM();
      const hardwareVal = this.masterObject.selectedBuckleColorType || '';
      const hardwareColorVal = this.masterObject.selectedBuckleName || '';

      const urlParams = new URLSearchParams(window.location.search);
      const productTitleEl = document.querySelector('.product-name');
      const productTitle = productTitleEl ? productTitleEl.textContent.trim() : '';
      const patternVal = urlParams.get('pattern') || productTitle;

      this.currentProductType = productType;

      const baseUrl = "https://d3rm6itks8gufu.cloudfront.net/";
      const iframeUrl = new URL(baseUrl + productType);

      if (sizeVal) iframeUrl.searchParams.set('size', sizeVal);
      if (patternVal) iframeUrl.searchParams.set('pattern', patternVal);
      if (hardwareVal) iframeUrl.searchParams.set('hardware', hardwareVal);
      if (hardwareColorVal) iframeUrl.searchParams.set('hardware_color', hardwareColorVal);

      // Set product type specific search parameter
      if (productType === 'cat-collar') {
        iframeUrl.searchParams.set('cat', 'true');
      } else if (productType === 'dog-leash') {
        iframeUrl.searchParams.set('leash', 'true');
      } else if (productType === 'martingale-collar') {
        iframeUrl.searchParams.set('martingale', 'true');
      } else if (productType === 'dog-harness') {
        iframeUrl.searchParams.set('harness', 'true');
      } else if (productType === 'dog-bandana') {
        iframeUrl.searchParams.set('bandana', 'true');
      }

      window.scrollTo({ top: 0, behavior: 'instant' });
      this.updateHeaderHeight();
      document.getElementById("iframe-loading-screen").style.display = "flex";
      this.elements.iframeOverlay.style.display = 'flex';
      document.body.classList.add('iframe-open');
      document.body.style.overflow = 'hidden';

      let getIframe = document.querySelector("#myIframe");
      getIframe.src = iframeUrl.toString();

      document.getElementById("iframe-loading-screen").style.display = "none";
      this.sendDataToIframe();
    }
    closeIframe() {
      if (this.elements.iframeOverlay.style.display === 'flex') {
        this.elements.iframeOverlay.style.display = 'none';
        document.body.classList.remove('iframe-open');
        document.body.style.overflow = '';

        // Clear query parameters from browser URL
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('pattern');
        newUrl.searchParams.delete('size');
        newUrl.searchParams.delete('leash_length');
        newUrl.searchParams.delete('hardware');
        newUrl.searchParams.delete('hardware_color');
        window.history.replaceState({}, '', newUrl.toString());
      }
    }
    openSecondIframe() {
      const iframe = document.getElementById("secondIframe");
      const iframeUrl = iframe.getAttribute('data-url');

      iframe.src = iframeUrl;

      const overlay = document.getElementById("secondIframeOverlay");
      window.open(iframeUrl, '_blank');

    }

    closeSecondIframe() {
      this.elements.secondIframeOverlay.style.display = 'none';
      document.body.classList.remove('iframe-open');
      document.body.style.overflow = '';
    }
    async fetchAndRenderVariants(productId = '8969048817879') {
      try {
        const response = await fetch(`${this.API_BASE_URL}/product/variants/8969048817879`);
        if (!response.ok) {
          throw new Error('Failed to fetch variants');
        }
        const data = await response.json();
        if (data.success && data.variants) {
          const container = document.querySelector('.sizing-select.custom-sizing-select');
          if (container) {
            // Keep the hidden fields if any, but clear the button children
            const inputs = container.querySelectorAll('input[type="hidden"]');
            container.innerHTML = '';
            inputs.forEach(input => container.appendChild(input));

            data.variants.forEach((v, index) => {
              const button = document.createElement('button');
              button.className = 'size-btn custom-size-btn';
              if (index === 0) {
                button.classList.add('selected');
              }

              const priceStr = String(v.price || '');
              const formattedPrice = priceStr.startsWith('$') ? priceStr : `$${priceStr}`;
              const variantJson = {
                id: v.id,
                model: v.model,
                prefix: v.prefix,
                minlength: v.sizeMinLength,
                maxlength: v.sizeMaxLength,
                width: v.width,
                price: formattedPrice,
                size: v.size
              };

              button.setAttribute('data-variant', JSON.stringify(variantJson));
              button.textContent = v.size;
              container.appendChild(button);
            });

            // Re-initialize the price update script listeners for the new buttons
            if (typeof initProductPriceUpdate === 'function') {
              initProductPriceUpdate();
            }
          }
        }
      } catch (error) {
        console.error('Error fetching variants:', error);
      }
    }

    sendDataToSecondIframe() {
      let getSecondIframe = document.querySelector("#secondIframe");
      getSecondIframe.src = "https://d2tiyrn0nbi00r.cloudfront.net/";
      if (getSecondIframe.src != "") {
        setTimeout(() => {
          getSecondIframe.contentWindow.postMessage(this.designerObject, "*");
        }, 2000);
      }
    }

    getAnimalType(data) {
      if (window.location.href.includes('cat=true') || (data && data.animalType === 'cat')) {
        return 'cat';
      }
      return 'dog';
    }

    showCorrectLoader(data) {
      const animalType = this.getAnimalType(data);
      const loaderId = this.loaderImages[animalType] || this.loaderImages.default;

      // Hide all loader images first
      Object.values(this.loaderImages).forEach(imageId => {
        const img = document.getElementById(imageId);
        if (img) img.style.display = "none";
      });

      // Show the appropriate loader image
      const loaderImage = document.getElementById(loaderId);
      if (loaderImage) {
        loaderImage.style.display = "block";
      }
    }

    prepareProductData(productInfo, productType) {
      // Normalize product type
      const normalizedType = this.productTypeMapping[productType] || productType.toUpperCase();

      const size = productInfo.properties?.size || '';
      const baseName = productInfo.name || 'Custom Product';
      // const productName = size ? `${baseName} - ${size}` : baseName;

      return {
        name: productInfo.name || 'Custom Product',
        price: productInfo.price,
        productId: productInfo.productId || productInfo.product_id || productInfo.createdProductId || null,
        preCreatedVariantId: productInfo.variantId || productInfo.variant_id || productInfo.preCreatedVariantId || null,
        variants: [{
          price: productInfo.price,
          sku: `CUST-${productType}-${Date.now()}`,
        }],
        properties: {
          properties: productInfo.properties,
          _productType: normalizedType
        }
      };
    }

    addProductSpecificProperties(itemProperties, productData, leashProductDetails) {
      const productType = productData.properties?._productType || '';
      const properties = productData.properties?.properties || {};

      itemProperties._bucklePreviewColor = properties.bucklePreviewColor || '';
      itemProperties._webbingPreviewColor = properties.webbingTextDetails?.webbingPreviewColor || '';

      // Handle collar types (DOG_COLLAR, CAT_COLLAR, MARTINGALE_COLLAR)
      if (productType.includes('COLLAR')) {
        itemProperties._customText = '';  // Empty for collars

        // Determine if buckle is plastic/breakaway
        const buckleMaterial = properties.materialType || '';
        const isPlastic = buckleMaterial.toLowerCase() === 'plastic' ||
          buckleMaterial.toLowerCase() === 'breakaway';

        // Handle engraving text based on material type
        if (isPlastic) {
          // Store with underscore to hide from cart display
          itemProperties._Line_1 = properties.engravingDetails?.engravingTextData?.[0]?.text || 'No Text';
          itemProperties._Line_2 = properties.engravingDetails?.engravingTextData?.[1]?.text || 'No Text';
          itemProperties._Line_3 = properties.engravingDetails?.engravingTextData?.[2]?.text || 'No Text';
          itemProperties._Line_4 = properties.engravingDetails?.engravingTextData?.[3]?.text || 'No Text';
        } else {
          // For non-plastic, show in cart as normal
          itemProperties['Line 1'] = properties.engravingDetails?.engravingTextData?.[0]?.text || 'No Text';
          itemProperties['Line 2'] = properties.engravingDetails?.engravingTextData?.[1]?.text || 'No Text';
          itemProperties['Line 3'] = properties.engravingDetails?.engravingTextData?.[2]?.text || 'No Text';
          itemProperties['Line 4'] = properties.engravingDetails?.engravingTextData?.[3]?.text || 'No Text';
        }

        // Common collar properties
        itemProperties['Webbing Text'] = properties.webbingTextDetails?.webbingCollarText || 'No Text';
        itemProperties._product_type = productType;
        itemProperties._design = properties.selectedPatternItems || properties._designName || 'No Selected Pattern';
        itemProperties._hardwareColor = properties.buckleColor || '';
        itemProperties._buckleMaterial = buckleMaterial;
        itemProperties._prefix = properties.prefix || '';

        // Font and stretch properties
        if (properties.engravingDetails?.engravingTextData) {
          for (let i = 0; i < 4; i++) {
            const textData = properties.engravingDetails.engravingTextData[i];
            if (textData) {
              itemProperties[`_line_${i + 1}_font`] = textData.fontName || '';
              itemProperties[`_line_${i + 1}_stretch`] = textData.isStretched || '';
            }
          }
        }

        // Webbing text properties
        itemProperties._web_text_size = properties.webbingTextDetails?.selectedCollarFontSize || '';
        itemProperties._web_text_face = properties.webbingTextDetails?.selectedCollarFont || '';
        itemProperties._web_text_CMYK = properties.webbingTextDetails?.collarTextColor || '';

        // Personalization summary
        itemProperties._personalization = properties.engravingDetails?.engravingTextData?.map(e => e.text || 'No Text').join(' ') || '';

        // Add leash details to collar product if leash exists
        if (leashProductDetails) {
          itemProperties._leash_id = leashProductDetails.id;
          itemProperties._leash_size = leashProductDetails.size;
        }

      } else if (productType.includes('LEASH')) {
        // Handle leash types (DOG_LEASH, CAT_LEASH)
        itemProperties._customText = properties._customText || '';
        itemProperties._product_type = productType;
        itemProperties._hardwareColors = `${properties.buckleColor || 'Default'} Hardware`;
        itemProperties._hardwareColor = properties.buckleColor || '';
        itemProperties._buckleMaterial = properties.materialType || '';
        itemProperties._design = properties.selectedPatternItems || properties._designName || 'No Selected Pattern';
        itemProperties._prefix = properties.prefix || '';
        itemProperties['Webbing Text'] = properties.webbingTextDetails?.webbingCollarText || 'No Text';

        if (leashProductDetails) {
          itemProperties._leash_size = leashProductDetails.size;
        }
      }

      return itemProperties;
    }

    handleIframeMessage(event) {
      if (event.data === 'cartLoader') {
        document.getElementById("iframe-loader").style.display = "flex";
        this.showCorrectLoader(event.data);
        return;
      }

      const sanitizedOrigin = event.origin.replace(/\/$/, '');
      const sanitizedIframeOrigin = this.IFRAME_ORIGIN.replace(/\/$/, '');
      if (sanitizedOrigin === sanitizedIframeOrigin || (event.data && event.data.type === 'ADD_TO_CART')) {
        document.getElementById("iframe-loader").style.display = "flex";
        this.showCorrectLoader(event.data);
        console.log('Received message from iframe:', event.data);
        const productsList = event.data.products || (event.data.product ? [event.data.product] : []);
        if (productsList.length > 0) {
          this.handleAddToCart(productsList);
        } else {
          console.warn('No products found in message:', event.data);
          const iframeLoader = document.getElementById("iframe-loader");
          if (iframeLoader) iframeLoader.style.display = "none";
        }
      }
    }

    async handleAddToCart(productsList) {
      try {
        if (!Array.isArray(productsList)) {
          productsList = [productsList];
        }

        if (this.isAddingToCart) return;
        this.isAddingToCart = true;

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-loading');
        }

        const productContainer = document.getElementById('product-container');
        const productId = productContainer ? productContainer.dataset.productId : null;
        let firstImageUrl = '';
        // Parent image is only a fallback; skip the request when every product already has its own image
        const needsFallbackImage = productsList.some(p => !p.properties?._image && !String(p.type || '').toLowerCase().includes('leash'));
        if (productId && needsFallbackImage) {
          try {
            const product = await this.getProductById(productId);
            firstImageUrl = product?.product?.images?.[0] || '';
          } catch (err) {
            console.error('Error fetching parent product images:', err);
          }
        }

        const preparedProducts = productsList.map(product => this.prepareProductData(product, product.type || 'collar'));

        // Sort products - leashes first for proper ID assignment
        preparedProducts.sort((a, b) => {
          const aType = (a.properties?._productType || '').toLowerCase();
          const bType = (b.properties?._productType || '').toLowerCase();
          if (aType.includes('leash')) return -1;
          if (bType.includes('leash')) return 1;
          return 0;
        });

        let leashProductDetails = null;
        const cartItems = [];
        const imageUploads = [];

        for (const productData of preparedProducts) {
          let variantId;
          let createdProductId = null;
          if (productData.preCreatedVariantId) {
            variantId = productData.preCreatedVariantId;
            createdProductId = productData.productId;
          } else {
            const createdProduct = await this.createCustomProduct(productData);
            if (!createdProduct.product?.variants?.[0]) {
              throw new Error('No variant found in the created product');
            }
            variantId = createdProduct.product.variants[0].id;
            createdProductId = createdProduct.product.id || createdProduct.id;
          }
          const origProps = productData.properties?.properties || {};
          const productType = productData.properties?._productType || '';
          const isLeash = productType.includes('LEASH');

          const placeholderImage = 'https://cdn.shopify.com/s/files/1/0678/1688/2375/files/placeholder.jpg?v=1740642279';

          // A leash only has its own image when customized directly; as an add-on
          // to a collar it has none, so it must not inherit the collar/parent image.
          const imageUrl = isLeash ? (origProps._image || '') : (origProps._image || firstImageUrl);
          if (createdProductId && imageUrl) {
            // Cart shows _image directly, so upload to the Shopify product in the background
            imageUploads.push(this.updateProductImage(createdProductId, imageUrl));
          }

          let itemProperties = {
            _size: origProps.size || '',
            _image: imageUrl || placeholderImage,
            _productType: productType
          };

          if (productType.includes('LEASH')) {
            leashProductDetails = {
              id: variantId,
              size: origProps.size || ''
            };
          }

          itemProperties = this.addProductSpecificProperties(itemProperties, productData, leashProductDetails);

          cartItems.push({
            id: variantId,
            quantity: 1,
            properties: itemProperties
          });
        }

        if (cartItems.length === 0) {
          throw new Error('No items to add to cart');
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: cartItems
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add products to cart');
        }

        if (typeof theme !== 'undefined' && theme.CartDrawer) {
          const cartDrawerInstance = new theme.CartDrawer();
          cartDrawerInstance.open();
        } else {
          const event = new CustomEvent('cart:open');
          document.dispatchEvent(event);
        }

        this.closeIframe();
        this.showNotification('Products added to cart successfully', 'success');

      } catch (error) {
        console.error('Error in cart process:', error);
        this.showNotification('Failed to add item to cart', 'error');
      } finally {
        this.isAddingToCart = false;
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.remove('is-loading');
        const iframeLoader = document.getElementById("iframe-loader");
        if (iframeLoader) iframeLoader.style.display = "none";
      }
    }

    async getProductById(productId) {
      const response = await fetch(`${this.API_BASE_URL}/product/${productId}`);
      if (!response.ok) {
        throw new Error('Failed to fetch product');
      }
      return await response.json();
    }


    async createCustomProduct(productData) {
      const response = await fetch(`${this.API_BASE_URL}/shopify-product/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData)
      });

      if (!response.ok) {
        this.setWithoutCustomizationLoading(false);
        throw new Error(`Failed to create product: ${await response.text()}`);
      }

      return await response.json();
    }

    async updateProductImage(productId, imageUrl) {
      if (!productId || !imageUrl) return;
      try {
        let blob;
        if (imageUrl.startsWith('data:')) {
          const res = await fetch(imageUrl);
          blob = await res.blob();
        } else if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('//')) {
          const fullUrl = imageUrl.startsWith('//') ? 'https:' + imageUrl : imageUrl;
          const res = await fetch(fullUrl);
          blob = await res.blob();
        } else {
          return;
        }

        const formData = new FormData();
        const mimeType = blob.type || 'image/png';
        const ext = mimeType.split('/')[1] || 'png';
        formData.append('product_images', blob, `product_${productId}.${ext}`);

        const response = await fetch(`${this.API_BASE_URL}/product/update/${productId}`, {
          method: 'PUT',
          body: formData
        });
        if (!response.ok) {
          console.warn(`Failed to update product image for product ${productId}:`, response.statusText);
        }
      } catch (err) {
        console.error(`Error updating product image for product ${productId}:`, err);
      }
    }

    initializeProductData() {
      const productContainer = document.getElementById('product-container');
      const productId = productContainer ? productContainer.dataset.productId : null;

      if (productId) {
        this.fetchAndRenderVariants(productId);
      } else {
        console.warn('No product ID found in URL or DOM');
      }
    }
  }

  function scrollToElement(elementId, type) {
    let sizeElement = document.getElementById("size-block");
    let top;
    if (type === "size") {
      top = sizeElement.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop);
    }

    if (type === "buckle") {
      top = elementId.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop);
    }
    // Smoothly scroll to the calculated position
    window.scrollTo({
      top: top - 20,
      behavior: 'smooth'
    });

  }

  function triggerZoomAnimation(element) {
    element.classList.add('zoom-effect');

    // Remove the class after the animation finishes
    element.addEventListener('animationend', () => {
      element.classList.remove('zoom-effect');
    });
  }

  window.selectedSize = function (element) {
    const buttons = document.querySelectorAll('.size-btn');
    buttons.forEach(btn => btn.classList.remove('selected'));
    element.classList.add('selected');
  };

  const productManager = new ProductManager();
});